// @owners { team: patients-team }
import { type AvailableShipmentFee } from '@alto/scriptdash/alto/orders/types/v1/available_shipment_fee';
import { type ShipmentFeeType, ShipmentFeeTypeMap } from '@alto/scriptdash/alto/orders/types/v1/shipment_fee_type';

/**
 * Creates a hash of all shipment fee types with null values.
 * Useful for initializing fee type hashes with all possible fee types.
 *
 * @template T - The type of value to use in the hash (defaults to AvailableShipmentFee)
 * @returns A record mapping each ShipmentFeeType to null
 */
export const getShipmentFeeTypesToNullHash = <T = AvailableShipmentFee>() => {
  return Object.values(ShipmentFeeTypeMap).reduce<Record<ShipmentFeeType, T | null>>(
    (hash, feeType) => {
      hash[feeType] = null;
      return hash;
    },
    {} as Record<ShipmentFeeType, T | null>,
  );
};
